<template>
  <AppButton class="AppBarMenuItem"
             :class="{
                'AppBarMenuItem--active': active,
                'AppBarMenuItem--hover': hover,
              }"
             text
             rounded="0"
             v-bind="$attrs"
  >
    <slot v-bind:active="active" />
    <span v-if="!$vuetify.display.mobile && label" class="ml-2">{{ label }}</span>
  </AppButton>
</template>

<script>
import AppButton from '@/common/buttons/AppButton.vue'

export default {
  name: 'AppBarMenuItem',
  components: { AppButton },
  inheritAttrs: false,
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      required: false,
    },
    hover: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped lang="scss">
  .v-btn.AppBarMenuItem {
    height: 100%;
    min-width: 0;

    &--active {
      color: rgb(var(--v-theme-primary));
      border-bottom: 4px solid rgb(var(--v-theme-primary));

      &:hover {
        background: rgb(var(--v-theme-primary-lighten-4));
      }
    }

    &:hover,
    &--hover {
      &::before {
        opacity: 0;
      }

      color: rgb(var(--v-theme-primary));
    }
  }
</style>
